import { render, staticRenderFns } from "./quick-emoji.vue?vue&type=template&id=86fd95f4&scoped=true&"
import script from "./quick-emoji.vue?vue&type=script&lang=js&"
export * from "./quick-emoji.vue?vue&type=script&lang=js&"
import style0 from "./quick-emoji.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./quick-emoji.vue?vue&type=style&index=1&id=86fd95f4&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "86fd95f4",
  null
  
)

export default component.exports